import { sendRequest } from './send-request';

export const sendComplaintsFormRequest = async (data: Record<string, any>) => {
  // NOSONAR
  const formattedData = {
    contactInfo: {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phoneNumber: data.contactMobileNumber,
      address: {
        line1: data.addressLine1,
        line2: data.addressLine2 || '',
        townOrCity: data.town,
        county: data.country,
        postcode: data.postCode,
      },
      preferredMethod: data.preferContact,
    },
    accountInfo: {
      businessUnit: 'O2',
      o2: {
        msisdn: data.mobileNumber,
        accountType: data.service === 'payAsYouGo' ? 'PAYG' : 'BUSINESS',
        isNonCustomer: data.isCustomer === 'no',
      },
      vm: {
        accountNumber: '',
      },
    },
    complaint: {
      parentCategory: data.issueDescription,
      childCategory: data.issueType,
      subject: data.issueDetails,
      details: data.issueDetails,
      resolution: data.howToFixTheIssue,
    },
  };

  return await sendRequest(formattedData);
};
